import React, { useState } from "react";
import styles from "./Training.module.css";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { Table } from "antd";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
const Training = () => {
  const [AddContactModal, setAddContactModal] = useState(false);
  const [actions, setActions] = useState(null);
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [role, setRole] = useState({
    value: "Admin",
    role: "admin",
    id: 1,
  });
  const [media, setMedia] = useState({
    value: "Video",
    role: "Video",
    id: 1,
  });
  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      width: "50px",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width: "250px",
      align: "center",

      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Role",
      key: "role",
      dataIndex: "role",
      // width: "250px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Media Type",
      key: "media_type",
      dataIndex: "media_type",
      // width: "200px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    // {
    //   title: "Status",
    //   key: "Status",
    //   dataIndex: "Status",
    //   width: "200px",
    //   align: "center",
    //   render: (text, record) => (
    //     <div className={styles.materialName}>
    //       <TextComponent className={styles.materialText} text={text} />
    //     </div>
    //   ),
    // },

    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      align: "center",

      render: (text, record) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/userManagement/training/viewTraining")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/userManagement/training/EditTraining")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      name: "Mixing SOPs",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "2",
      name: " Oven SOPs",
      role: "Staff Member",
      media_type: "PDF",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "3",
      name: "Mixing SOPs",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "1",
      name: "Mixing SOPs",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "2",
      name: " Oven SOPs",
      role: "Staff Member",
      media_type: "PDF",
      Status: "Aug 2, 2025",
      action: "View",
    },
    {
      No: "3",
      name: "Mixing SOPs",
      role: "Supervisor",
      media_type: "Video",
      Status: "Aug 2, 2025",
      action: "View",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Training Library"}
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/userManagement/training/addTraining")}
        submitButtonText={"New Media"}
        // showBackIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
          rowClassName={styles.tableRow}
        />
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setIsModal(false)}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        cancelBtnTitle={"No"}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>
      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Role"}
          labelClass={styles.labelClass}
          value={role}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Supervisor",
              role: "supervisor",
              id: 1,
            },
            {
              value: "Staff Member",
              role: "staff",
              id: 2,
            },
          ]}
          onChange={(e) => setRole(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Media Type"}
          labelClass={styles.labelClass}
          value={media}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Video",
              role: "Video",
              id: 1,
            },
            {
              value: "PDF",
              role: "PDF",
              id: 2,
            },
          ]}
          onChange={(e) => setMedia(e)}
        />
      </Modal>
    </div>
  );
};

export default Training;
